__turbopack_context__.v({
  "enter": "BlogHome-module-scss-module__pRWnuG__enter",
  "exit": "BlogHome-module-scss-module__pRWnuG__exit",
  "fade-in": "BlogHome-module-scss-module__pRWnuG__fade-in",
  "fade-out": "BlogHome-module-scss-module__pRWnuG__fade-out",
  "fade-out-80": "BlogHome-module-scss-module__pRWnuG__fade-out-80",
  "hero": "BlogHome-module-scss-module__pRWnuG__hero",
  "heroBadge": "BlogHome-module-scss-module__pRWnuG__heroBadge",
  "heroInner": "BlogHome-module-scss-module__pRWnuG__heroInner",
  "heroLead": "BlogHome-module-scss-module__pRWnuG__heroLead",
  "heroTitle": "BlogHome-module-scss-module__pRWnuG__heroTitle",
  "heroTitleHighlight": "BlogHome-module-scss-module__pRWnuG__heroTitleHighlight",
  "modalCard": "BlogHome-module-scss-module__pRWnuG__modalCard",
  "modalCategory": "BlogHome-module-scss-module__pRWnuG__modalCategory",
  "modalClose": "BlogHome-module-scss-module__pRWnuG__modalClose",
  "modalCloseIcon": "BlogHome-module-scss-module__pRWnuG__modalCloseIcon",
  "modalGuideLink": "BlogHome-module-scss-module__pRWnuG__modalGuideLink",
  "modalHeader": "BlogHome-module-scss-module__pRWnuG__modalHeader",
  "modalNav": "BlogHome-module-scss-module__pRWnuG__modalNav",
  "modalNavIcon": "BlogHome-module-scss-module__pRWnuG__modalNavIcon",
  "modalNavNext": "BlogHome-module-scss-module__pRWnuG__modalNavNext",
  "modalNavPrev": "BlogHome-module-scss-module__pRWnuG__modalNavPrev",
  "modalOverlay": "BlogHome-module-scss-module__pRWnuG__modalOverlay",
  "modalPreview": "BlogHome-module-scss-module__pRWnuG__modalPreview",
  "modalPreviewIframe": "BlogHome-module-scss-module__pRWnuG__modalPreviewIframe",
  "modalPreviewInner": "BlogHome-module-scss-module__pRWnuG__modalPreviewInner",
  "modalTitle": "BlogHome-module-scss-module__pRWnuG__modalTitle",
  "pageNav": "BlogHome-module-scss-module__pRWnuG__pageNav",
  "pageNavIcon": "BlogHome-module-scss-module__pRWnuG__pageNavIcon",
  "pageNumber": "BlogHome-module-scss-module__pRWnuG__pageNumber",
  "pageNumberActive": "BlogHome-module-scss-module__pRWnuG__pageNumberActive",
  "pagination": "BlogHome-module-scss-module__pRWnuG__pagination",
  "postArrow": "BlogHome-module-scss-module__pRWnuG__postArrow",
  "postArrowIcon": "BlogHome-module-scss-module__pRWnuG__postArrowIcon",
  "postBody": "BlogHome-module-scss-module__pRWnuG__postBody",
  "postCard": "BlogHome-module-scss-module__pRWnuG__postCard",
  "postCategory": "BlogHome-module-scss-module__pRWnuG__postCategory",
  "postDescription": "BlogHome-module-scss-module__pRWnuG__postDescription",
  "postList": "BlogHome-module-scss-module__pRWnuG__postList",
  "postMeta": "BlogHome-module-scss-module__pRWnuG__postMeta",
  "postTitle": "BlogHome-module-scss-module__pRWnuG__postTitle",
  "root": "BlogHome-module-scss-module__pRWnuG__root",
  "searchIcon": "BlogHome-module-scss-module__pRWnuG__searchIcon",
  "searchInput": "BlogHome-module-scss-module__pRWnuG__searchInput",
  "searchLabel": "BlogHome-module-scss-module__pRWnuG__searchLabel",
  "section": "BlogHome-module-scss-module__pRWnuG__section",
  "sectionHeader": "BlogHome-module-scss-module__pRWnuG__sectionHeader",
  "sectionHeaderTight": "BlogHome-module-scss-module__pRWnuG__sectionHeaderTight",
  "sectionPosts": "BlogHome-module-scss-module__pRWnuG__sectionPosts",
  "sectionSubtitle": "BlogHome-module-scss-module__pRWnuG__sectionSubtitle",
  "sectionTitle": "BlogHome-module-scss-module__pRWnuG__sectionTitle",
  "sectionVideos": "BlogHome-module-scss-module__pRWnuG__sectionVideos",
  "slide-in-from-bottom": "BlogHome-module-scss-module__pRWnuG__slide-in-from-bottom",
  "slide-in-from-left": "BlogHome-module-scss-module__pRWnuG__slide-in-from-left",
  "slide-in-from-right": "BlogHome-module-scss-module__pRWnuG__slide-in-from-right",
  "slide-in-from-top": "BlogHome-module-scss-module__pRWnuG__slide-in-from-top",
  "slide-out-to-bottom": "BlogHome-module-scss-module__pRWnuG__slide-out-to-bottom",
  "slide-out-to-left": "BlogHome-module-scss-module__pRWnuG__slide-out-to-left",
  "slide-out-to-right": "BlogHome-module-scss-module__pRWnuG__slide-out-to-right",
  "slide-out-to-top": "BlogHome-module-scss-module__pRWnuG__slide-out-to-top",
  "tabButton": "BlogHome-module-scss-module__pRWnuG__tabButton",
  "tabButtonActive": "BlogHome-module-scss-module__pRWnuG__tabButtonActive",
  "tabRow": "BlogHome-module-scss-module__pRWnuG__tabRow",
  "videoCard": "BlogHome-module-scss-module__pRWnuG__videoCard",
  "videoCategory": "BlogHome-module-scss-module__pRWnuG__videoCategory",
  "videoDuration": "BlogHome-module-scss-module__pRWnuG__videoDuration",
  "videoGrid": "BlogHome-module-scss-module__pRWnuG__videoGrid",
  "videoMeta": "BlogHome-module-scss-module__pRWnuG__videoMeta",
  "videoPlay": "BlogHome-module-scss-module__pRWnuG__videoPlay",
  "videoPlayTriangle": "BlogHome-module-scss-module__pRWnuG__videoPlayTriangle",
  "videoThumb": "BlogHome-module-scss-module__pRWnuG__videoThumb",
  "videoThumbGradient0": "BlogHome-module-scss-module__pRWnuG__videoThumbGradient0",
  "videoThumbGradient1": "BlogHome-module-scss-module__pRWnuG__videoThumbGradient1",
  "videoThumbGradient2": "BlogHome-module-scss-module__pRWnuG__videoThumbGradient2",
  "videoThumbGradient3": "BlogHome-module-scss-module__pRWnuG__videoThumbGradient3",
  "videoThumbGradient4": "BlogHome-module-scss-module__pRWnuG__videoThumbGradient4",
  "videoThumbGradient5": "BlogHome-module-scss-module__pRWnuG__videoThumbGradient5",
  "videoThumbImg": "BlogHome-module-scss-module__pRWnuG__videoThumbImg",
  "videoTitle": "BlogHome-module-scss-module__pRWnuG__videoTitle",
  "zoom-in": "BlogHome-module-scss-module__pRWnuG__zoom-in",
  "zoom-out": "BlogHome-module-scss-module__pRWnuG__zoom-out",
});
